// Feature announcements shown as dismissible banners on the dashboards.
//
// To announce a new feature, add ONE entry to the top of this array:
//   id:       unique, stable string — NEVER reuse or change once shipped
//             (it's the per-user "dismissed" key). Suffix with the date.
//   audience: 'all' | 'admin' | 'therapist'  (who sees it)
//   icon:     emoji shown before the title
//   title:    short bold lead-in
//   text:     the message
//
// Banners are dismissed per-user in the browser (localStorage). They appear on
// the next dashboard load/login, not on a page that's already open.
export const ANNOUNCEMENTS = [
  {
    id: 'client-attention-address-links-2026-08-25',
    audience: 'therapist',
    icon: '🔔',
    title: 'New: Client attention alerts + address-update links',
    text: "Your dashboard now flags clients who need a look: anyone who turned 18 while still marked a minor (update signatures/ROI, then un-check “Is minor”), consent paperwork over a year old (send a fresh intake link), and client birthdays coming up this week 🎂. Alerts clear themselves once the paperwork or profile is updated. Also new: “Send Address-Update Link” on a client's profile emails them a secure page to update their own address, phone, and email — track it under Sent Links. Big thanks to Laura for suggesting these features!",
  },
  {
    id: 'billing-vs-calendar-2026-08-25',
    audience: 'admin',
    icon: '🔍',
    title: 'New: Billing vs Calendar checker',
    text: "Catch sessions a therapist forgot to submit: Collections → Billing vs Calendar compares each therapist's Acuity calendar against their submitted sessions for any date range and flags kept appointments with no submission (red) and submissions with no appointment (yellow). Calendar data goes back to June 1, 2026; name matching is approximate, so eyeball flags before following up.",
  },
  {
    id: 'profile-update-requests-therapist-2026-08-17',
    audience: 'therapist',
    icon: '📋',
    title: 'New: Profile update requests from the office',
    text: "When the office needs client info filled in (usually a diagnosis code for an insurance invoice), you'll see a popup at login listing what's needed — click “Update now” to jump straight to that client's profile, or “Remind me next time” to defer. You can always find open requests under My Clients → Profile Updates. Requests clear automatically the moment you save the requested fields.",
  },
  {
    id: 'profile-update-requests-admin-2026-08-17',
    audience: 'admin',
    icon: '📋',
    title: 'New: Request profile updates from therapists',
    text: "Need a diagnosis code for an insurance invoice? On a client's profile (Clients → Client Profiles), click “Request Update”, check the fields you need, add a note, and send — the assigned therapist gets a popup at their next login. Generating an invoice with no dx code on file also shows a one-click “Request it from the therapist” banner. You'll get a banner here when the therapist fills it in.",
  },
  {
    id: 'acuity-calendar-widget-2026-07-03',
    audience: 'all',
    icon: '🗓️',
    title: 'New: Manage appointments right from your dashboard',
    text: "Book, reschedule, or cancel without leaving the portal: tap ⋯ on any appointment in My Schedule, or + Book to grab an open slot (clients get the usual Acuity emails). Office team: use the new Calendar Manager widget to do the same on any therapist's calendar.",
  },
  {
    id: 'movable-dashboard-widgets-2026-07-01',
    audience: 'all',
    icon: '🧩',
    title: 'New: Make Your Dashboard Yours',
    text: "You can now rearrange your dashboard! Drag the ✥ handle on any widget's title bar to move it, hit ✕ to hide one you don't use, and open ⚙ Customize (top right) to bring widgets back or reset the default layout. Your arrangement saves automatically and follows you on any device.",
  },
  {
    id: 'therapist-card-update-link-2026-07-01',
    audience: 'therapist',
    icon: '💳',
    title: 'New: Send a Card-Update Link',
    text: "You can now email a client a secure link to add or update the card on file. Go to My Clients → Client Profiles, select the client, then click the “Send Card-Update Link” button (next to Generate Intake Link) — confirm the prefilled email, add a note if you like, and send.",
  },
  {
    id: 'shout-out-reactions-2026-06-25',
    audience: 'all',
    icon: '🎉',
    title: 'New portal feature',
    text: "React to shout-outs! Add an emoji to a teammate's shout-out on the Team page.",
  },
  {
    id: 'sent-links-2026-06-24',
    audience: 'therapist',
    icon: '🔗',
    title: 'New: Sent Links',
    text: "Track the welcome/intake and ROI links you've sent under My Clients → Sent Links — and you'll get a banner here when a client completes one.",
  },
  {
    id: 'payment-links-2026-06-24',
    audience: 'admin',
    icon: '💳',
    title: 'New: Payment Links',
    text: 'See the status of every card-collection link, and email card-update links, under Collections → Payment Links.',
  },
];
